import * as React from 'react';

import type { RelanceJournalClient } from '@/api/relance-journal-client';
import { HttpRelanceJournalClient } from '@/api/relance-journal-client.http';

// =============================================================================
// relance-journal-client-context.tsx — Injection du RelanceJournalClient (DI seam).
// =============================================================================
// R15-COM-05. Permet de substituer le client sans toucher l'UI. Par DÉFAUT : l'adaptateur HTTP RÉEL — la
// route réelle n'a donc AUCUN provider à câbler (parité supplier-monitoring / reminders). Les tests de
// composant injectent le StubRelanceJournalClient via ce provider (enveloppe locale).

const defaultRelanceJournalClient: RelanceJournalClient =
  new HttpRelanceJournalClient();

const RelanceJournalClientContext =
  React.createContext<RelanceJournalClient>(defaultRelanceJournalClient);

export interface RelanceJournalClientProviderProps {
  client?: RelanceJournalClient | undefined;
  children: React.ReactNode;
}

export function RelanceJournalClientProvider({
  client = defaultRelanceJournalClient,
  children,
}: RelanceJournalClientProviderProps): React.JSX.Element {
  return (
    <RelanceJournalClientContext.Provider value={client}>
      {children}
    </RelanceJournalClientContext.Provider>
  );
}

export function useRelanceJournalClient(): RelanceJournalClient {
  return React.useContext(RelanceJournalClientContext);
}
